import './AddFileUploadElementStyle.less';

import { Icon } from '@opendoor/bricks';
import React from 'react';

interface IAddFileUploadElementProps {
  className?: string;
  content: string;
  onAddFileUploadElement?: (() => void) | null;
}

const AddFileUploadElement: React.SFC<IAddFileUploadElementProps> = (
  props: IAddFileUploadElementProps,
) => (
  <div
    className={`add-file-upload-element file-upload ${props.className || ''}`}
    onClick={props.onAddFileUploadElement || null}
  >
    <div className="upload-container">
      <div className="content">
        <div className="plus-icon">
          <Icon name="home-love-close" />
        </div>
        <div className="file-name-container additional-document-text-container">
          <div className="file-name">{props.content}</div>
        </div>
      </div>
    </div>
  </div>
);

export default AddFileUploadElement;
